import {Box, useMediaQuery, VStack} from "@chakra-ui/react";
import {LogoHeader} from "../parts/LogoHeader";
import {ForgetPasswordForm} from "../../../components/forms";
import styles from "../login/styles";
import {useForm} from "react-hook-form";
import {useState} from "react";
import {SuccessfulSent} from "./SuccessfulSent";

export const ForgetPassword = () => {
    const [isMobile] = useMediaQuery("(max-width: 1270px)");
    const [sent, setSent] = useState(false)
    const {
        register,
        handleSubmit,
        formState: {errors, isValid, isDirty}
    } = useForm({
        mode: "onTouched",
        defaultValues: {
            email: '',
        }
    })

    const submit = (e) => {
        setSent(true)
    }


    return (
        <Box
            mt={isMobile ? '20px' : '86px'}
            mx={'auto'}
            mb={isMobile ? '0' : '250px'}
            w={{base: '90%', md: '674px', lg: '674px'}}
            css={styles.loginContainer}>
            <VStack
                p={isMobile ? '16px' : '53px'}
                pt={isMobile ? '24px' : '52px'}
                boxShadow={'0px 4px 4px 0px #00000040'}
                border={'1px solid #23262F99'}
                position={'relative'}
                overflow={'hidden'}
                borderRadius={'32px'}>
                {
                    sent ? <SuccessfulSent/> :
                        <>
                            <LogoHeader
                                title={'Forgot your password?'}
                                text={'Please enter the email address associated with your account and we\'ll send you a verification code.'}
                                textFontSize={'body.sm'}
                            />
                            <ForgetPasswordForm
                                register={register}
                                submit={submit}
                                handleSubmit={handleSubmit}
                                errors={errors}
                                isValid={isValid}
                                isDirty={isDirty}
                                isMobile={isMobile}/>
                        </>
                }
            </VStack>

        </Box>
    )
}